import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/client/lib/api-client'

export interface Opportunity {
  url: string
  position: number
  impressions: number
  clicks: number
  ctr: number
  seoScore: number | null
  wordCount: number | null
  flags: string[]
}

export function useOpportunities(siteId: string) {
  return useQuery({
    queryKey: ['sites', siteId, 'opportunities'],
    queryFn: () => apiClient.get<{ opportunities: Opportunity[] }>(`/api/sites/${siteId}/opportunities`),
    enabled: !!siteId,
    staleTime: 10 * 60 * 1000, // 10 min
  })
}
